/* Higher Level Creations theme: one script for every page. No dependencies.
   Everything here is an enhancement: with scripts off the pages still show all content and the bag
   still works through the cart page. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var H = window.HLC || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search/suggest', allUrl: '/collections/all', inStock: 0, t: {} };
  var T = H.t || {};
  var money = function (cents) { var n = cents / 100; return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };

  /* header height, and a hairline once the page has moved */
  var hdr = $('header.site-hdr');
  if (hdr) {
    var setH = function () { root.style.setProperty('--hdr', hdr.offsetHeight + 'px'); };
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(hdr); else addEventListener('resize', setH);
  }

  /* header menus: hover or focus on a desktop, tap on a phone. Every group is a real link list in the page. */
  var menuBtns = $$('[data-menu]'), openMenu = null, openT = 0, closeT = 0;
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var panelOf = function (b) { return d.getElementById('menu-' + b.getAttribute('data-menu')); };
  var scrim = null;
  if (menuBtns.length) { scrim = d.createElement('div'); scrim.className = 'h-scrim'; d.body.appendChild(scrim); }
  function setMenu(id) {
    openMenu = id;
    menuBtns.forEach(function (b) {
      var on = b.getAttribute('data-menu') === id, p = panelOf(b);
      b.setAttribute('aria-expanded', String(on));
      if (!p) return;
      p.hidden = !on;
      if (on && !p._warm) { p._warm = 1; $$('[data-img]', p).forEach(function (a) { new Image().src = a.getAttribute('data-img'); }); }
    });
    if (scrim) scrim.classList.toggle('on', !!id);
  }
  $$('.h-panel').forEach(function (p) {
    var pic = $('.h-pic img', p);
    if (!pic) return;
    var show = function (src) {
      if (!src || pic.getAttribute('src') === src) return;
      pic.removeAttribute('srcset'); pic.setAttribute('src', src);
      if (pic.animate && !calm) pic.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 380, easing: EASE });
    };
    $$('[data-img]', p).forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.getAttribute('data-img')); });
      a.addEventListener('focus', function () { show(a.getAttribute('data-img')); });
    });
  });
  menuBtns.forEach(function (b) {
    var id = b.getAttribute('data-menu'), p = panelOf(b);
    if (!p) return;
    if (canHover) [b, p].forEach(function (el) {
      el.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function () { setMenu(id); }, el === b && openMenu === null ? 90 : 0); });
      el.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { setMenu(null); }, 220); });
    });
    b.addEventListener('click', function (e) {
      var isButton = b.tagName === 'BUTTON';
      if (isButton) { e.preventDefault(); setMenu(openMenu === id && !canHover ? null : id); return; }
      if (!canHover && openMenu !== id) { e.preventDefault(); setMenu(id); }
    });
    b.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setMenu(id); var first = $('a', p); if (first) first.focus(); }
    });
  });
  if (menuBtns.length) {
    d.addEventListener('click', function (e) { if (openMenu && !(e.target.closest && e.target.closest('.site-hdr'))) setMenu(null); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openMenu) setMenu(null); });
    if (hdr) hdr.addEventListener('focusout', function (e) { if (openMenu && e.relatedTarget && !hdr.contains(e.relatedTarget)) setMenu(null); });
  }

  /* reveal on scroll (the homepage's own mechanism). Content is never left hidden:
     no observer, a hidden tab, the theme editor or a slow frame all end in the visible state. */
  var reveals = $$('.reveal');
  var showAll = function () { reveals.forEach(function (e) { e.classList.add('in'); }); };
  if (!('IntersectionObserver' in window) || d.hidden || window.Shopify && window.Shopify.designMode) showAll();
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      reveals.forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight * 1.1) e.classList.add('in'); });
    }, 1200);
    d.addEventListener('visibilitychange', function () { if (d.hidden) showAll(); });
  }
  d.addEventListener('shopify:section:load', showAll);

  /* on a phone the guide's contents list starts folded so the article is the first thing read */
  if (innerWidth <= 900) $$('.toc details').forEach(function (t) { t.open = false; });

  /* accordions open and close with height, not a jump */
  d.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('details > summary');
    if (!s || calm || !s.animate) return;
    var det = s.parentElement, c = s.nextElementSibling;
    if (!c) return;
    e.preventDefault();
    if (det._a) det._a.cancel();
    if (!det.open) {
      det.open = true;
      var h = c.offsetHeight;
      det._a = c.animate([{ height: '0px', opacity: 0, overflow: 'hidden' }, { height: h + 'px', opacity: 1, overflow: 'hidden' }], { duration: 380, easing: EASE });
    } else {
      var h2 = c.offsetHeight;
      var a = c.animate([{ height: h2 + 'px', opacity: 1, overflow: 'hidden' }, { height: '0px', opacity: 0, overflow: 'hidden' }], { duration: 260, easing: EASE });
      det._a = a;
      a.onfinish = function () { det.open = false; det._a = null; };
    }
  });

  /* ---------- the bag: Shopify's cart, drawn in the drawer ---------- */
  var ovl = $('[data-ovl]'), drawer = $('[data-drawer="bag"]'), srch = $('[data-drawer="search"]'), navD = $('[data-drawer="nav"]');
  var cart = null;
  var closeAll = function () {
    [drawer, srch, navD, ovl].forEach(function (el) { if (el) el.classList.remove('open'); });
    [drawer, srch, navD].forEach(function (el) { if (el) el.setAttribute('aria-hidden', 'true'); });
    var burger = $('[data-nav-open]'); if (burger) burger.setAttribute('aria-expanded', 'false');
    root.style.overflow = '';
  };
  var open = function (el) {
    if (!el) return;
    closeAll(); setMenu(null); el.classList.add('open'); if (ovl) ovl.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    root.style.overflow = 'hidden';
  };
  /* the nav drawer is rendered inside the header section, so it follows the header's Menu setting; it is moved to the
     body here, out of the sticky header's stacking context, and re-placed when the editor reloads the header */
  var placeNav = function (el) { if (el && el.parentNode !== d.body) d.body.appendChild(el); };
  placeNav(navD);
  d.addEventListener('shopify:section:load', function (e) {
    var nd = e.target && e.target.querySelector ? e.target.querySelector('[data-drawer="nav"]') : null;
    if (!nd) return;
    if (navD && navD !== nd && navD.parentNode) navD.parentNode.removeChild(navD);
    navD = nd; placeNav(navD); $$('[data-close]', navD).forEach(function (b) { b.addEventListener('click', closeAll); });
  });
  if (ovl) ovl.addEventListener('click', closeAll);
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });

  var inCart = function (vid) { return !!(cart && cart.items.some(function (i) { return String(i.variant_id) === String(vid); })); };
  function paintBag() {
    if (!cart) return;
    var n = cart.item_count;
    $$('[data-bag-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; });
    $$('[data-add]').forEach(function (b) {
      var on = inCart(b.getAttribute('data-add'));
      b.classList.toggle('added', on);
      var lab = on ? (T.added || 'Added to bag') : (T.add || 'Add to bag');
      if (b.hasAttribute('data-add-text')) b.textContent = lab; else { b.setAttribute('aria-label', lab); b.title = lab; }
    });
    if (!drawer) return;
    var list = $('[data-bag-list]', drawer), foot = $('[data-bag-foot]', drawer);
    if (!n) {
      list.innerHTML = '<p class="copy" style="padding:22px 0">' + esc(T.empty || 'Your bag is empty.') + '</p>';
      foot.innerHTML = '<a href="' + esc(H.allUrl) + '" class="btn btn-ink btn-lg" style="justify-content:center">' + esc(T.shopAll || 'Shop everything in stock') + '</a>';
      return;
    }
    list.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_144x144_crop_center$1$2') : '';
      return '<div class="bag-item"><a href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72">' : '') + '</a><div style="display:flex;flex-direction:column;gap:8px;align-items:flex-start"><a class="t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><span class="p">' + money(i.final_line_price) + '</span>' + (i.quantity > 1 ? '<span class="q">' + i.quantity + ' in the bag</span>' : '') + '<button type="button" data-rm="' + esc(i.key) + '">' + esc(T.remove || 'Remove') + '</button></div></div>';
    }).join('');
    foot.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:baseline"><span class="lbl">' + esc(T.subtotal || 'Subtotal') + '</span><span class="serif" style="font-size:30px;line-height:1">' + money(cart.total_price) + '</span></div><a href="' + esc(H.root.replace(/\/$/, '')) + '/checkout" class="btn btn-ink btn-lg" style="justify-content:center;padding:19px 30px">' + esc(T.checkout || 'Checkout') + '</a>' + (T.cartNote ? '<p class="note">' + esc(T.cartNote) + '</p>' : '');
  }
  function loadCart() {
    return fetch(H.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { cart = j; paintBag(); return j; });
  }
  function postJSON(url, body) {
    return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  if (drawer) drawer.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]');
    if (rm) { rm.disabled = true; postJSON(H.cartChange, { id: rm.getAttribute('data-rm'), quantity: 0 }).then(loadCart).catch(loadCart); }
  });
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add]');
    if (b) {
      if (b.form) e.preventDefault();
      var vid = b.getAttribute('data-add');
      if (b.hasAttribute('data-add-open')) open(drawer);
      if (inCart(vid)) { paintBag(); if (b.hasAttribute('data-add-open')) open(drawer); return; }
      b.disabled = true;
      postJSON(H.cartAdd, { items: [{ id: Number(vid), quantity: 1 }] }).then(function () {
        return loadCart();
      }).then(function () {
        b.disabled = false;
        var bagBtn = $('[data-bag-open]');
        if (bagBtn && bagBtn.animate && !calm) bagBtn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.14)' }, { transform: 'scale(1)' }], { duration: 520, easing: EASE });
      }).catch(function (err) {
        b.disabled = false;
        var msg = (err && (err.description || err.message)) || 'That piece could not be added.';
        var note = $('[data-add-note]');
        if (note) { note.textContent = msg; note.hidden = false; } else alert(msg);
      });
      return;
    }
    if (e.target.closest && e.target.closest('[data-bag-open]')) { e.preventDefault(); open(drawer); loadCart(); return; }
    if (e.target.closest && e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest && e.target.closest('[data-nav-open]')) { e.preventDefault(); open(navD); var bg = $('[data-nav-open]'); if (bg) bg.setAttribute('aria-expanded', 'true'); }
  });
  loadCart();

  /* ---------- search: Shopify's predictive search, in the panel ---------- */
  var input = srch && $('[data-search-input]', srch), res = srch && $('[data-res]', srch), note = srch && $('[data-note]', srch), sT = 0, lastQ = '';
  function paintSearch() {
    if (!input) return;
    var q = input.value.trim();
    if (!q) { res.innerHTML = ''; note.textContent = H.inStock ? H.inStock + ' ' + (T.pieces || 'pieces') + ' ' + (T.inStock || 'in stock') : ''; return; }
    if (q === lastQ) return;
    lastQ = q;
    var base = /\.json$/.test(H.search) ? H.search : H.search + '.json';
    var url = base + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,tag';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      if (input.value.trim() !== q) return;
      var hits = (j.resources && j.resources.results && j.resources.results.products) || [];
      res.innerHTML = hits.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2') : '';
        return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') + '<span class="t">' + esc(p.title) + '</span><span class="p">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
      }).join('');
      note.textContent = hits.length ? (hits.length === 1 ? '1 ' + (T.piece || 'piece') : hits.length + ' ' + (T.pieces || 'pieces')) + (hits.length >= 12 ? ', the first 12' : '') : (T.none || 'No piece in stock matches that.');
    }).catch(function () { note.textContent = 'Search is not available right now.'; });
  }
  function openSearch() {
    open(srch);
    setTimeout(function () { if (input) input.focus(); }, 60);
    lastQ = ''; paintSearch();
  }
  if (input) input.addEventListener('input', function () { clearTimeout(sT); sT = setTimeout(paintSearch, 180); });

  /* ---------- collection: sort, sold pieces, load more (over the tiles on the page) ---------- */
  $$('[data-grid]').forEach(function (grid) {
    var scope = grid.closest('section') || d;
    var tiles = $$(':scope > li', grid);
    var step = Number(grid.getAttribute('data-grid')) || 24, shown = step;
    var sortSel = $('[data-sort]', scope), soldBtn = $('[data-sold-toggle]', scope), more = $('[data-more]', scope);
    var showSold = true, primed = false;
    var num = function (li, k) { return Number(li.getAttribute('data-' + k)) || 0; };
    var cmp = {
      'weight-asc': function (a, b) { return (num(a, 'g') || 1e9) - (num(b, 'g') || 1e9); },
      'weight-desc': function (a, b) { return num(b, 'g') - num(a, 'g'); },
      'price-asc': function (a, b) { return num(a, 'p') - num(b, 'p'); },
      'price-desc': function (a, b) { return num(b, 'p') - num(a, 'p'); },
      'ppg-asc': function (a, b) { return (num(a, 'ppg') || 1e9) - (num(b, 'ppg') || 1e9); }
    };
    function paint() {
      var key = sortSel ? sortSel.value : 'weight-asc';
      var live = tiles.filter(function (li) { return !li.classList.contains('sold'); }).sort(cmp[key] || cmp['weight-asc']);
      var sold = tiles.filter(function (li) { return li.classList.contains('sold'); });
      var order = live.concat(sold);
      var visible = 0;
      order.forEach(function (li) {
        grid.appendChild(li);
        var isSold = li.classList.contains('sold');
        var ok = (!isSold || showSold) && visible < shown;
        if (ok) visible++;
        li.hidden = !ok;
      });
      var total = live.length + (showSold ? sold.length : 0);
      if (more) more.hidden = visible >= total;
      /* the grid is sorted here, not in Liquid, so the first row's photographs are switched to eager once, after the first paint */
      if (!primed) {
        primed = true;
        var n = 0;
        order.some(function (li) {
          if (li.hidden) return false;
          var img = $('img', li);
          if (img) { img.loading = 'eager'; if (n === 0) img.setAttribute('fetchpriority', 'high'); }
          return ++n >= 4;
        });
      }
    }
    if (sortSel) sortSel.addEventListener('change', function () { shown = step; paint(); });
    if (soldBtn) soldBtn.addEventListener('click', function () { showSold = !showSold; soldBtn.setAttribute('aria-pressed', String(showSold)); paint(); });
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); shown += step; paint(); });
    paint();
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-main]', g), count = $('[data-count]', g), thumbs = $$('[data-thumb]', g), i = 0, n = thumbs.length;
    if (!main || !n) return;
    function go(k) {
      i = (k + n) % n;
      var t = thumbs[i];
      main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || '';
      if (main.animate && !calm) main.animate([{ opacity: 0.25 }, { opacity: 1 }], { duration: 420, easing: EASE });
      if (count) count.textContent = (i + 1) + ' / ' + n;
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
    var prev = $('[data-prev]', g), next = $('[data-next]', g);
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
  });

  /* ---------- questions page: search and the turning headline ---------- */
  var fq = $('[data-faq-search]');
  if (fq) {
    var groups = $$('[data-faq-group]'), none = $('[data-faq-none]');
    fq.addEventListener('input', function () {
      var q = fq.value.trim().toLowerCase(), any = 0;
      groups.forEach(function (gr) {
        var n = 0;
        $$('details', gr).forEach(function (det) {
          var hit = !q || det.textContent.toLowerCase().indexOf(q) >= 0;
          det.hidden = !hit; det.open = !!q && hit;
          if (hit) n++;
        });
        gr.hidden = !n; any += n;
      });
      if (none) none.hidden = any > 0;
    });
  }
  var rot = $('[data-rot]');
  if (rot) {
    var items = [];
    try { items = JSON.parse(rot.getAttribute('data-rot')); } catch (err) {}
    var link = rot.closest('a'), r = 0;
    if (items.length > 1 && !calm) setInterval(function () {
      if (d.hidden) return;
      var swap = function () {
        r = (r + 1) % items.length;
        rot.textContent = items[r][0];
        if (link) { link.setAttribute('href', items[r][1]); link.setAttribute('aria-label', 'Jump to: ' + items[r][0]); }
        if (rot.animate) rot.animate([{ transform: 'translateY(60%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 520, easing: EASE });
      };
      if (!rot.animate) return swap();
      var out = rot.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(-60%)', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.5,0,.75,0)' });
      out.onfinish = swap;
    }, 4000);
  }

  /* ---------- header shadow once the page has scrolled ---------- */
  var tick = false;
  addEventListener('scroll', function () {
    if (tick) return; tick = true;
    requestAnimationFrame(function () {
      tick = false;
      var y = window.scrollY;
      if (hdr) hdr.classList.toggle('scrolled', y > 6);
    });
  }, { passive: true });

  /* ---------- arrive on the section a link names ---------- */
  if (location.hash && location.hash.length > 1) {
    var id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (err) { id = null; }
    if (id) {
      var tries = 0, done = 0, stopped = false, stop = function () { stopped = true; };
      addEventListener('wheel', stop, { passive: true, once: true });
      addEventListener('touchstart', stop, { passive: true, once: true });
      addEventListener('keydown', stop, { once: true });
      var timer = setInterval(function () {
        var el = d.getElementById(id);
        if (stopped || ++tries > 40) { clearInterval(timer); return; }
        if (!el) return;
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (++done >= 3) clearInterval(timer);
      }, 150);
    }
  }

  /* ---------- guide contents: ids on the headings, the list from them ---------- */
  var toc = $('[data-toc]'), prose = $('[data-prose]');
  if (toc && prose) {
    var used = {};
    var items2 = $$('h2', prose).filter(function (h) { return !h.closest('.take') && !h.closest('.short'); }).map(function (h) {
      var sec = h.closest('section[id]');
      var sid = sec && sec !== prose ? sec.id : (h.id || h.textContent.toLowerCase().replace(/[^a-z0-9 ]/g, '').trim().split(/\s+/).slice(0, 3).join('-') || 'section');
      if (!sec || sec === prose) { while (used[sid]) sid += '-2'; used[sid] = 1; h.id = sid; }
      return '<li><a href="#' + sid + '">' + esc(h.textContent) + '</a></li>';
    });
    toc.innerHTML = items2.join('');
  }
})();

/* Facebook page feed: the plugin renders at a fixed width and height, so give it the frame's own size before it loads */
(function () {
  var f = document.querySelector('.fb-feed[data-src]');
  if (!f) return;
  var lastW = 0, lastH = 0, t, tries = 0;
  function fit() {
    var cw = f.parentElement.clientWidth, ch = f.clientHeight;
    if (!cw || !ch) { if (tries++ < 40) setTimeout(fit, 250); return; }
    var w = Math.max(180, Math.min(500, Math.round(cw) - 6));
    var h = Math.max(120, Math.round(ch));
    if (Math.abs(w - lastW) < 6 && Math.abs(h - lastH) < 24) return;
    lastW = w; lastH = h;
    f.setAttribute('width', w); f.setAttribute('height', h);
    f.src = f.getAttribute('data-src').replace('{w}', w).replace('{h}', h);
  }
  fit();
  setTimeout(fit, 1500);
  addEventListener('load', fit);
  addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 250); });
  if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) fit(); }, { rootMargin: '600px' }).observe(f);
})();
